import { useEffect } from 'react';
import { Badge, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/bootstrap/Button';
import Popovers from '../../../components/bootstrap/Popovers';
import Icon from '../../../components/icon/Icon';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import {
	messageUnreadPages,
	requestLeadPage,
	progressOperator,
	progressAgency,
	agencyTemplateSms,
	agencyPagesAppointment,
} from '../../../menu';
import { useAgencyStore } from '../../../stores/useAgencyStore';
import { useNotificationsStore } from '../../../stores/useNotificationsStore';
import { useOperatorStore } from '../../../stores/useOperatorStore';
import { useUserStore } from '../../../stores/useUserStore';

const DefaultHeader = () => {
	const navigate = useNavigate();
	const logout = useUserStore((state) => state.logout);
	const handleLogout = async () => {
		await logout();
		navigate('/login');
	};
	const [user] = useUserStore((state) => [state.user]);
	const [agency, getAgencyInformation] = useAgencyStore((state) => [
		state.agencyInformation,
		state.getAgencyInformation,
	]);

	const [operator, getOperatorInformation] = useOperatorStore((state) => [
		state.operatorInformation,
		state.getOperatorInformation,
	]);

	const [countNewNotifications, count] = useNotificationsStore((state) => [
		state.countNewNotifications,
		state.countNewNotification,
	]);

	useEffect(() => {
		if (user) countNewNotifications();
		if (user?.uuidAgency) getAgencyInformation(user.uuidAgency);
		if (user?.uuidOperator) getOperatorInformation(user.uuidOperator);
	}, [countNewNotifications]);

	const goToLeads = () => {
		navigate(`../homepage`);
	};
	const goToPratiche = () => {
		navigate(`../pratiche`);
	};
	const createLeads = () => {
		navigate(`../lead`);
	};

	const goToProgress = () => {
		navigate(`../${progressOperator.progress.path}`);
	};
	const goToReportAgency = () => {
		navigate(`../${progressAgency.progress.path}`);
	};
	const goToSupport = () => {
		navigate(`../support`);
	};

	const goToNotification = () => {
		navigate(`../${messageUnreadPages.message.path}`);
	};

	const goToRequestPage = () => {
		navigate(`../${requestLeadPage.requestLead.path}`);
	};

	const goToTemplateSms = () => {
		navigate(`../${agencyTemplateSms.templateSms.path}`);
	};

	const goToAppointment = () => {
		navigate(`../${agencyPagesAppointment.appointment.path}`);
	};
	const goToEsiti = () => {
		navigate(`../esiti`);
	};

	const goToSendSms = () => {
		navigate(`../massive-sms`);
	};

	const goChargeSms = () => {
		navigate(`../payment`);
	};

	const goUploadFileLeads = () => {
		navigate(`../upload-file`);
	};

	const goToFileUploaded = () => {
		navigate(`../file-uploaded`);
	};
	const goToTickets = () => {
		navigate(`../admin-support`);
	};

	if (!user) {
		return <></>;
	} else
		return (
			<Header>
				<HeaderLeft>
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Dropdown>
								<Dropdown.Toggle variant='primary'>Anagrafiche</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={goToLeads}>Le mia anagrafiche</Dropdown.Item>
									<Dropdown.Item onClick={goUploadFileLeads}>Carica file anagrafiche</Dropdown.Item>
									<Dropdown.Item onClick={goToRequestPage}>Richiedi anagrafiche</Dropdown.Item>
									<Dropdown.Item onClick={goToFileUploaded}>File caricati</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					)}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={goToAppointment}>
								Appuntamenti
							</Button>
						</div>
					)}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={goToPratiche}>
								Pratiche
							</Button>
						</div>
					)}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Dropdown>
								<Dropdown.Toggle variant='dark'>SMS</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={goToSendSms}>Invia SMS Massivo</Dropdown.Item>
									<Dropdown.Item onClick={goToTemplateSms}>Template SMS</Dropdown.Item>
									{/* <Dropdown.Item onClick={goChargeSms}>Ricarica SMS</Dropdown.Item> */}
								</Dropdown.Menu>
							</Dropdown>
						</div>
					)}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Button color='dark' onClick={goToEsiti}>
								Esiti
							</Button>
						</div>
					)}
					{user?.role === 'OPERATOR' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={createLeads}>
								Nuovo cliente
							</Button>
						</div>
					)}
					{user?.role === 'OPERATOR' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={goToLeads}>
								Le mie anagrafiche
							</Button>
						</div>
					)}
					{/* {user?.role === 'OPERATOR' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={goToProgress}>
								Report giornaliero
							</Button>
						</div>
					)} */}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Button color='dark' onClick={goToReportAgency}>
								Report
							</Button>
						</div>
					)}
					{user?.role === 'AGENCY' && (
						<div className='d-inline-flex'>
							<Button color='dark' onClick={goToSupport}>
								Supporto
							</Button>
						</div>
					)}

					{user?.role === 'OPERATOR' &&
						operator &&
						operator.groups &&
						operator.groups.length > 0 && (
							<div
								className='d-flex align-items-center gap-2'
								style={{
									maxWidth: '100%',
									marginBottom: '0.5rem',
									padding: '0.5rem',
									backgroundColor: 'rgba(0, 0, 0, 0.02)',
									borderRadius: '0.5rem',
								}}>
								<small className='text-muted fw-semibold'>Gruppi:</small>
								<div className='d-flex align-items-center gap-1 flex-wrap'>
									{operator.groups.slice(0, 3).map((group, index) => (
										<Badge
											key={group}
											style={{
												fontSize: '0.8rem',
												padding: '0.4rem 0.6rem',
												cursor: 'default',
												whiteSpace: 'nowrap',
											}}
											bg={index % 2 === 0 ? 'primary' : 'success'}
											className='d-inline-flex align-items-center gap-1'>
											<Icon icon='LocalOffer' size='sm' />
											{group}
										</Badge>
									))}
									{operator.groups.length > 3 && (
										<Dropdown>
											<Dropdown.Toggle
												as={Badge}
												variant='secondary'
												style={{
													fontSize: '0.8rem',
													padding: '0.4rem 0.6rem',
													cursor: 'pointer',
													whiteSpace: 'nowrap',
													border: 'none',
												}}
												id='dropdown-groups'>
												+{operator.groups.length - 3} altri
											</Dropdown.Toggle>
											<Dropdown.Menu
												style={{
													maxHeight: '300px',
													overflowY: 'auto',
													minWidth: '200px',
												}}>
												<Dropdown.Header>
													<small className='fw-semibold'>
														Tutti i gruppi ({operator.groups.length})
													</small>
												</Dropdown.Header>
												<Dropdown.Divider />
												{operator.groups.map((group, index) => (
													<Dropdown.Item
														key={group}
														text
														style={{
															padding: '0.5rem 1rem',
															cursor: 'default',
														}}>
														<div className='d-flex align-items-center gap-2'>
															<Icon
																icon='LocalOffer'
																size='sm'
																style={{
																	color: index % 2 === 0 ? '#0d6efd' : '#198754',
																}}
															/>
															<span>{group}</span>
														</div>
													</Dropdown.Item>
												))}
											</Dropdown.Menu>
										</Dropdown>
									)}
								</div>
							</div>
						)}
				</HeaderLeft>
				<HeaderRight>
					{user?.role === 'ADMIN' && (
						<div className='d-inline-flex'>
							<Button color='primary' onClick={goToTickets}>
								Ticket assistenza
							</Button>
						</div>
					)}
					{/* <div className='d-inline-flex'>
						<Button color='primary' onClick={goToNotification}>
							Notifiche {count !== 0 && <Badge bg='success'>{count}</Badge>}
						</Button>
					</div> */}
					<div className='d-inline-flex'>
						{user?.role === 'AGENCY' && (
							<Popovers trigger='hover' desc='Crediti disponibili'>
								<div className='mx-2'>
									<Icon icon='MonetizationOn' size={'2x'} />
									<b>{agency?.credits}</b>
								</div>
							</Popovers>
						)}
						{user?.role === 'AGENCY' && (
							<Popovers trigger='hover' desc='Crediti SMS disponibili'>
								<div className='mx-2'>
									<Icon icon='Phone' size={'2x'} />
									<b>{agency?.creditiSms?.toFixed(2)}</b>
								</div>
							</Popovers>
						)}
						<div>
							<Icon icon='Person' size={'2x'} />
							<b>
								{user?.role === 'OPERATOR'
									? operator?.username?.toUpperCase()
									: user?.username?.toUpperCase()}
							</b>
						</div>
					</div>
					<Button color='primary' onClick={handleLogout}>
						Logout <Icon icon='Logout' />
					</Button>
				</HeaderRight>
			</Header>
		);
};

export default DefaultHeader;
